// Блок 3: Проблема — PAS Framework, 3 карточки

const problems = [
  {
    title: 'Одни и те же вопросы каждый день',
    description: '60–70% обращений — повторяющиеся. Операторы тратят часы на копипаст одних и тех же ответов.',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8} aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182" />
      </svg>
    ),
  },
  {
    title: 'Клиенты ждут ответа часами',
    description: 'Пока оператор разгребает почту, клиент уходит к конкурентам. Скорость ответа — критический фактор.',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8} aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    title: 'Операторы тонут в рутине',
    description: 'Выгорание, ошибки из-за усталости, высокая текучка. Креативные задачи остаются за бортом.',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8} aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.182 16.318A4.486 4.486 0 0012.016 15a4.486 4.486 0 00-3.198 1.318M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z" />
      </svg>
    ),
  },
] as const;

export function ProblemSection(): JSX.Element {
  return (
    <section className="py-20 lg:py-28 bg-surface-base">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-14">
          <h2 className="font-heading text-3xl sm:text-4xl font-extrabold text-text-primary tracking-tight">
            Знакомо?
          </h2>
          <p className="mt-4 text-text-secondary text-base sm:text-lg leading-relaxed">
            Нанять ещё одного оператора — дорого. Обычные чат-боты отвечают как роботы.
            Клиенты ждут часами. Операторы выгорают.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {problems.map((p) => (
            <div
              key={p.title}
              className="group relative bg-white border border-border-subtle rounded-card p-6 transition-all duration-200 hover:shadow-medium hover:border-border-strong"
            >
              <div className="w-10 h-10 rounded-comp bg-accent-danger-light text-accent-danger flex items-center justify-center mb-4 transition-colors group-hover:bg-accent-danger/15">
                {p.icon}
              </div>
              <h3 className="font-heading text-lg font-bold text-text-primary mb-2">
                {p.title}
              </h3>
              <p className="text-sm text-text-secondary leading-relaxed">
                {p.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
